<div class="kpi-container module-placeholder-host">
	<div *ngIf="!hasNoData && !isFetchingData" class="row kpi-row">
		<div class="col-3 kpi-col">
			<new-kpi-item [kpi]="kpi.impressions" [titleTooltip]="'info_box.influencer.new_kpi_impression' | translate"></new-kpi-item>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item [kpi]="kpi.reach" [titleTooltip]="'info_box.influencer.new_kpi_reach' | translate"></new-kpi-item>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item [kpi]="kpi.engagement" [titleTooltip]="'info_box.influencer.new_kpi_engagement' | translate"></new-kpi-item>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item [kpi]="kpi.engagementRate" [titleTooltip]="engagementRateTooltip" [isPercentValue]="true"></new-kpi-item>
		</div>
	</div>

	<div *ngIf="hasNoData || isFetchingData" class="row kpi-row">
		<div class="col-3 kpi-col">
			<new-kpi-item-placeholder [name]="'Impressions'" [titleTooltip]="'info_box.influencer.new_kpi_impression' | translate">
			</new-kpi-item-placeholder>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item-placeholder [name]="'Reach'" [titleTooltip]="'info_box.influencer.new_kpi_reach' | translate">
			</new-kpi-item-placeholder>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item-placeholder [name]="'Engagement'" [titleTooltip]="'info_box.influencer.new_kpi_engagement' | translate">
			</new-kpi-item-placeholder>
		</div>

		<div class="col-3 kpi-col">
			<new-kpi-item-placeholder [name]="'Interaction Rate'" [titleTooltip]="engagementRateTooltip" [isPercentValue]="true">
			</new-kpi-item-placeholder>
		</div>
	</div>

	<influencer-module-placeholder *ngIf="hasNoData || isFetchingData" class="module-placeholder-container" [width]="361"
		[isFetchingData]="isFetchingData" [hasNoData]="hasNoData">
	</influencer-module-placeholder>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/new-kpi/new-kpi.component.html